import Head from "next/head";
import { ProtectRoute } from "~/hooks/useAuth";
import DashboardHeader from "../../components/DashboardHeader";
import DashboardPage from "~/components/DashboardPage";

const Dashboard = () => {
    return (
        <>
            <Head>
                <title>Dashboard | Fotop Serviços</title>
            </Head>

            <DashboardHeader />
            <DashboardPage />
        </>
    );
};

export default ProtectRoute(Dashboard, { title: "Dashboard | Fotop Serviços" });
